export default "__VITE_ASSET__CkB6bFYR__"